/**
 * Helper to load WASM modules from the public folder
 * This bypasses Create React App's module resolution restrictions
 */

export async function loadWasmModule(modulePath, wasmPath) {
  try {
    // Fetch the JavaScript glue code as text
    const jsResponse = await fetch(modulePath);
    const jsCode = await jsResponse.text();

    // Create a blob URL for the JS code
    const blob = new Blob([jsCode], { type: 'application/javascript' });
    const blobUrl = URL.createObjectURL(blob);

    // Import the module from the blob URL
    const module = await import(/* webpackIgnore: true */ blobUrl);

    // Initialize with WASM binary
    await module.default(wasmPath);

    // Clean up blob URL
    URL.revokeObjectURL(blobUrl);

    return module;
  } catch (error) {
    console.error('Failed to load WASM module:', error);
    throw error;
  }
}
